import React from 'react';
import PropTypes from 'prop-types';
import { quoteCreationType } from '../otherQuoteEntities';
import { TextMosaic, TextMosaicDto, MosaicWall } from '@ami/react/core';

const buttons = [
  { id: quoteCreationType.byMakeAndModel, label: 'Make & Model' },
  { id: quoteCreationType.byWeightClass, label: 'Category' },
];

const QuoteCreationTypeComponent = ({
  selectedType,
  onChange,
  showOptions,
}) => {
  const options = showOptions
    ? buttons.map((x) => (
        <TextMosaic
          widthColumns={5}
          key={x.id}
          data={new TextMosaicDto({ ...x, selected: x.id === selectedType })}
          onClick={() => onChange(x.id)}
        />
      ))
    : null;
  return (
    <MosaicWall
      title="Select By"
      childrenContainerClassName="row justify-content-center"
    >
      {options}
    </MosaicWall>
  );
};

QuoteCreationTypeComponent.propTypes = {
  onChange: PropTypes.func.isRequired,
  selectedType: PropTypes.number,
  showOptions: PropTypes.bool.isRequired,
};

export default QuoteCreationTypeComponent;
